import React from 'react';
import { WrapperBox } from './FsTransactionsTable.style-elements';
import FsTransactionRow from './FsTransactionRow';
import { FsTransactionRowDataProps } from './FsTransactionRow/FsTransactionRow';

interface FsTransactionsTableProps {
  transactions: FsTransactionRowDataProps[];
}

const FsTransactionsTable: React.FC<FsTransactionsTableProps> = ({
  transactions,
}) => {
  return (
    <WrapperBox>
      {transactions?.map(({ id, ...props }) => (
        <FsTransactionRow key={id} id={id} {...props} />
      ))}
    </WrapperBox>
  );
};

export default FsTransactionsTable;
